var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavNet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.78955,
    y: 9.47369,
    width: 5.05263,
    height: 3.78947,
    rx: 1.5,
    transform: "rotate(90 3.78955 9.47369)",
    fill: "#072B3B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 9.47369,
    width: 5.05263,
    height: 3.78947,
    rx: 1.5,
    transform: "rotate(90 24 9.47369)",
    fill: "#072B3B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5264,
    y: 3.78949,
    width: 5.05263,
    height: 3.78947,
    rx: 1.5,
    transform: "rotate(-180 14.5264 3.78949)",
    fill: "#072B3B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5264,
    y: 24,
    width: 5.05263,
    height: 3.78947,
    rx: 1.5,
    transform: "rotate(-180 14.5264 24)",
    fill: "#072B3B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9473,
    y: 8.8421,
    width: 6.31579,
    height: 13.8947,
    rx: 2,
    transform: "rotate(90 18.9473 8.8421)",
    fill: "#0397AB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.84204,
    y: 5.05261,
    width: 6.31579,
    height: 13.8947,
    rx: 2,
    fill: "#0397AB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavNet);
export default __webpack_public_path__ + "static/media/nav_net.c1393902e3052b4f36088ccd6e9841a1.svg";
export { ForwardRef as ReactComponent };